import React from 'react'
import { connect } from 'react-redux'
import { getNews, setOpened, setNewsFilter, setNewLoaded, hidePrintModal } from 'state/actions'
import { catIdToString, sourceIdToObj } from 'lib/i18n'
import NewsPageDom from 'elements/NewsPageDom'
import PrintModal from '../elements/PrintModal.jsx'
import nesProp from 'nested-property'
import i18n from 'lib/i18n'
const _ = i18n('news')

@connect(
    state => ({
        ...state.news,
        newsId: state.app.opened,
        isPhone: state.responsive.isPhone,
        isTablet: state.responsive.isTablet,
        opened: Boolean(app.opened),
    })
)
export default class News extends React.Component {
    static propTypes = {
        dispatch: React.PropTypes.func.isRequired,
        items: React.PropTypes.array.isRequired,
    }

    componentDidMount() {
        const { dispatch } = this.props
        this.update()
        let promisesForLoading = []

        let categoryPromise = new Promise((resolve, reject) => {
            catIdToString('', () => {
                resolve()
            })
        })

        let sourcePromise = new Promise((resolve, reject) => {
            sourceIdToObj('', () => {
                resolve()
            })
        })

        promisesForLoading.push(categoryPromise)
        promisesForLoading.push(sourcePromise)

        Promise.all(promisesForLoading)
            .then(() => {
                dispatch(setNewLoaded())
            })
    }

    componentDidUpdate() { this.update() }

    update() {
        const { dispatch } = this.props

        dispatch(getNews())
    }

    render() {
        const { items, filter, newsId, loaded, dispatch, isPhone, opened, isTablet } = this.props
        let newsIndex = newsId && items.findIndex(item => item._id === newsId)
        if (!newsIndex && !isPhone && !isTablet) {
            newsIndex = 0
        } 
        const newsItem = items[newsIndex]
        let filteredItems = items

        if (!loaded) {
            return (<div></div>)
        }
        const lowerFilters = filter && filter.trim().toLowerCase().split(/\s/) || []

        if (lowerFilters) {
            for (const lowerFilter of lowerFilters) {
                filteredItems = filteredItems.filter(item => {
                    return item && item.title && (
                        item.title.toLowerCase().includes(lowerFilter) ||

                        (item.teaser && item.teaser.toLowerCase().includes(lowerFilter)) ||
                        (item.categoryIds && item.categoryIds
                            .map(catId => {
                                let result = catIdToString(catId)
                                result = String(result)
                                return result && result.toLowerCase() || ''
                            }
                            )
                            .some(s => {
                                let result = String(s)
                                return result && result.includes(lowerFilter)
                            })
                        ) ||
                        (item.sourceIds && item.sourceIds
                            .map(sourceId => {
                                let sourceObj = sourceIdToObj(sourceId)
                                return sourceObj && sourceObj.name && (typeof sourceObj.name == 'string') && sourceObj.name.toLowerCase()
                            })
                            .some(s => {
                                let result = String(s)
                                return result && result.includes(lowerFilter)
                            })
                        )
                    )
                })
            }
        }
        newsIndex = filteredItems && filteredItems.indexOf(newsItem)

        return (
            <div>
                <NewsPageDom
                    filter={filter}
                    list={filteredItems}
                    newsPosition={newsIndex}
                    newsToOpen={newsItem}
                    setFilter={(filter) => { return dispatch(setNewsFilter(filter)) }}
                    onOpen={(itemId) => { return dispatch(setOpened(itemId)) }}
                    isPhone={isPhone}
                    isTablet={isTablet}
                    opened={opened}
                />
                <PrintModal
                    confirmationLabel={_("ok")}
                    onConfirmation={() => {
                        dispatch(hidePrintModal("newsPrintModal", true))
                    }}
                    options={{ showPrintButton: true, printButtonLabel: _("print") }}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/news.jsx